import React from 'react'

export const Loading = () => {
  return <div className="text-center pt-5">LOADING...</div>
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js